import { Range } from 'react-date-range'
import { FilterParam } from '../../../FilterBar.types'
import { DashboardDateRangeDefaultsLabel } from './DashboardDateRangeFilterDropdown.constants'
import { DashboardDateRangeDefaults } from './DashboardDateRangeFilterDropdown.types'

export const getDashboardDateRangeToggleText = (
  appliedDateRange: Range,
  appliedFilters: Record<string, string[]>,
): string => {
  if (appliedDateRange.startDate && appliedDateRange.endDate) {
    return 'Custom'
  }
  if (appliedFilters[FilterParam.DASHBOARD_DATE_RANGE]) {
    return DashboardDateRangeDefaultsLabel[
      appliedFilters[
        FilterParam.DASHBOARD_DATE_RANGE
      ][0] as DashboardDateRangeDefaults
    ]
  }
  return DashboardDateRangeDefaultsLabel[
    DashboardDateRangeDefaults.LAST_30_DAYS
  ]
}
